import Swiper from 'swiper';
import {updateCounter} from '%widgets%/widget-slider';

export const initiateSliderAlerts = widget => {
  const swiperEl = widget.querySelector('.swiper');

  if (!swiperEl) return;

  const id = widget.id;
  const swiperPagination = widget.querySelector('.swiper-pagination');
  const swiperBtnNext = widget.querySelector('.swiper-btn-next');
  const swiperBtnPrev = widget.querySelector('.swiper-btn-prev');
  const swiperCounter =
    widget.querySelector('.swiper-counter') ||
    document.querySelector(`.swiper-counter[data-bs-target="#${id}"]`);
  const slides = swiperEl.querySelectorAll('.swiper-slide');

  let swiper;
  let activeIndex = 0;
  const totalSlides = slides.length;

  updateCounter(swiperCounter, 0, totalSlides);

  swiper = new Swiper(swiperEl, {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    simulateTouch: false,
    pagination: {
      el: swiperPagination
        ? swiperPagination
        : id && document.querySelector(`.swiper-pagination[data-bs-target="#${id}"]`),
      clickable: true,
      renderBullet: (index, className) => {
        return `<span data-index="${index}" class="${className}"></span>`;
      },
    },
    navigation: {
      nextEl: swiperBtnNext
        ? swiperBtnNext
        : id && document.querySelector(`.swiper-btn-next[data-bs-target="#${id}"]`),
      prevEl: swiperBtnPrev
        ? swiperBtnPrev
        : id && document.querySelector(`.swiper-btn-prev[data-bs-target="#${id}"]`),
    },
    on: {
      init(swiper) {
        widget.classList.add('is-swiper-initialized');
        activeIndex = swiper.realIndex;
        swiperEl.setAttribute('data-index', activeIndex);
        updateCounter(swiperCounter, activeIndex, totalSlides);
      },
      slideChange(swiper) {
        if (swiper.realIndex !== activeIndex) {
          activeIndex = swiper.realIndex;
          swiperEl.setAttribute('data-index', activeIndex);

          updateCounter(swiperCounter, activeIndex, totalSlides);

          swiperEl.closest('.modal')?.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      },
    },
  });

  swiperEl.closest('.modal')?.addEventListener('shown.bs.modal', () => {
    swiper.update();
  });
  swiperEl.closest('.modal')?.addEventListener('show.bs.modal', ({relatedTarget}) => {
    const {id} = relatedTarget.closest('.swiper-slide').dataset;

    if (id) {
      const targetIndex = Array.from(swiper.slides).findIndex(slide => slide.dataset.id === id);

      if (targetIndex !== -1) {
        swiper.slideToLoop(targetIndex, 0);
      }
    }
  });

  return {
    swipers: [swiper],
    destroy: () => {
      swiper?.destroy?.(true, true);
    },
  };
};
